// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'clipboard-pencil-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path d='M3.937 7.882h6.75m-6.75 2.813h4.5m-4.5 2.812h2.25m9.167-6.153L8.5 14l-1 4.5' />
          <circle cx='7.25' cy='3.15' r='.5' />
        </mask>
      </defs>
      <path
        fill='currentColor'
        stroke='currentColor'
        d='m16.992 11.16-5.688 5.688-2.808.576.576-2.808 5.688-5.688c.288-.288.72-.432 1.152-.432.432 0 .792.144 1.152.432.288.288.432.72.432 1.152-.072.36-.216.792-.504 1.08Z'
      />
      <path
        fill='currentColor'
        stroke='currentColor'
        d='M6.84 17.424H1.656c-.288 0-.576-.144-.792-.36-.216-.216-.36-.504-.36-.792V4.464c0-.288.144-.576.36-.792.216-.216.504-.36.792-.36h2.808c0-.72.288-1.44.792-2.016C5.76.72 6.48.504 7.272.504c.72 0 1.44.288 2.016.792.504.504.792 1.224.792 2.016h2.88c.288 0 .576.144.792.36.216.216.36.504.36.792V7.2L7.56 13.68l-.72 3.744Z'
        mask={`url(#${maskId})`}
      />
    </>
  );
};

export const viewBox = '0 0 18 18';
